// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'
import { api } from '../../../../utility/constants'

// ColorMaster LIST

export const ColorMasterlist = createAsyncThunk('ColorMaster/ColorMasterlist', async params => {
  try {
  const response = await axios.post(`${api.api_url}/master/color/colorListjwt`, params)
   if (response && response.data && response.data.body && response.data.body.token) {
   params = {jwtToken:response.data.body.token}
   const response1 = await axios.post(`${api.api_url}/master/color/colorList`, params)
   if (response1 && response1.data && response1.data.body) {
    return {
      params,
      ColorMasterlist:response1.data.body && response1.data.body.ColorArray ? response1.data.body.ColorArray : [],
      TotalColor:response1.data.body && response1.data.body.TotalColor ? response1.data.body.TotalColor : 0
    }
   } else {
    return {
      params,
      ColorMasterlist:response1.data.body ? response1.data.body.ColorArray : [],
      TotalColor:response1.data.body ? response1.data.body.TotalColor : 0
    }
   }
  } else {
    return {
      params,
      ColorMasterlist:response.data.body ? response.data.body.ColorArray : [],
      TotalColor: response.data.body ? response.data.body.TotalColor : 0
    }
   }
  } catch (error) {
    return {
      params,
      ColorMasterlist: [],
      TotalColor:0
    }
  }
})

//saveData Api
export const saveData = createAsyncThunk('ColorMaster/saveData', async params => {
  try {
  const response = await axios.post(`${api.api_url}/master/color/saveColorjwt`, params)
   if (response && response.data && response.data.body && response.data.body.token) {
   params = {jwtToken:response.data.body.token}
   const response1 = await axios.post(`${api.api_url}/master/color/saveColor`, params)
   if (response1 && response1.data && response1.data.body) {
    return {
      statusFlag:response1.data.body && response1.data.body.statusFlag ? response1.data.body.statusFlag : 2,
      message:response1.data.body.message
    }
   } else {
    return {
      statusFlag:response1.data.body ? response1.data.body.statusFlag : 2,
      message:response1.data.body ? response1.data.body.message : 'Server not reachable.Please try again later'
    }
   }
  } else {
    return {
      statusFlag:response.data.body ? response.data.body.statusFlag : 2,
      message: response.data.body ? response.data.body.message : 'Server not reachable.Please try again later'
    }
   }
  } catch (error) {
    return {
      statusFlag: 2,
      message:'Server not reachable.Please try again later'
    }
  }
})

//deleteData Api
export const deleteData = createAsyncThunk('ColorMaster/deleteData', async params => { 
  const response = await axios.post(`${api.api_url}/master/color/deleteColorjwt`, params)  
  if (response && response.data && response.data.body && response.data.body.token) { 
    params = {jwtToken:response.data.body.token}
   const response1 = await axios.post(`${api.api_url}/master/color/deleteColor`, params)
   if (response1 && response1.data && response1.data.body) { 
    return { 
      statusFlag:response1.data.body.statusFlag, 
      message:response1.data.body.message
    }
   }
  } else { 
    return {  
      statusFlag:response.data.statusFlag,
      message:response.data.message
    }
   }
})
export const ColorMasterSlice = createSlice({
  name: 'ColorMaster',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    ColorMasterlist:[],
    TotalColor: 0,
    statuslist:[],
    statusFlag:0,
    statuscode:0
  },
  reducers: {
    handleStatusFlag: (state, action) => {
      state.statusFlag = action.payload.statusFlag
    }
  },
  extraReducers: builder => {
    builder.addCase(saveData.fulfilled, (state, action) => {
      state.statusFlag = action.payload.statusFlag
      state.message = action.payload.message
    })
    .addCase(deleteData.fulfilled, (state, action) => {
      state.message = action.payload.message
     state.statusFlag = action.payload.statusFlag
    })
    .addCase(ColorMasterlist.fulfilled, (state, action) => {
      state.ColorMasterlist = action.payload.ColorMasterlist
      state.TotalColor = action.payload.TotalColor
      state.params = action.payload.params
    })
  }
})
export const {
  handleStatusFlag
} = ColorMasterSlice.actions
export default ColorMasterSlice.reducer
